export const EVENT_AGENDA = '/events/{0}/agendas'